export default "__VITE_ASSET__B5l82Kim__"